module.exports = __webpack_public_path__ + "static/media/Rosatom-Light.8dae0dee.webp";